export const range = (start: number, end: number) => {
  const length = end - start + 1
  return Array.from({ length }, (_, i) => start + i)
}

export const fill = (count: number) => {
  return range(0, count - 1)
}

export const nonZero = (value: number | undefined) => {
  return value !== undefined && value > 0
}

export const sum = (values: Array<number>) => {
  return values.reduce((result, current) => {
    return result + current
  }, 0)
}

export const getBigInt = (value: any): bigint | false => {
  try {
    const bigIntValue = BigInt(value)
    return bigIntValue
  } catch {
    return false
  }
}
